import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';
const confirm = Modal.confirm;

import FormCertificacion from '../formularios/FormCertificacion';
import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import insertCertificacion from '../../../graphql/mutations/tramites/insertCertificacion.graphql';
import crearCertificacionConVenta from '../../../graphql/mutations/tramites/crearCertificacionConVenta.graphql';
import insertDetalleVenta from '../../../graphql/mutations/venta/insertDetalleVenta.graphql';
import insertVenta from '../../../graphql/mutations/venta/insertVenta.graphql';
import insertVentaCompleta from '../../../graphql/mutations/venta/insertVentaCompleta.graphql';
import getEnvironment from '../../../graphql/querys/common/getEnvironment.graphql';

import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

import { verPdf } from '../../common/funciones/verPdf';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertCertificacion, {
    name: 'createCert',
  }),
  graphql(crearCertificacionConVenta, {
    name: 'crearCertificacionConVenta',
  }),
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(insertDetalleVenta, {
    name: 'insertDetalleVenta',
  }),
  graphql(insertVenta, {
    name: 'insertVenta',
  }),
  graphql(insertVentaCompleta, {
    name: 'insertVentaCompleta',
  }),
  graphql(getEnvironment, {
    name: 'getEnvironment',
  }),
  graphql(getUsuario)
)
class CrearCertificacion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      existeVenta: false,
      persona: {},
      id_TipoCertificacion: '',
      cantidad: 0,
      step: 0,
      guardado: false,
      loading: false,
      detalles: [],
      datosPosnet: {},
      extras: {},
    };

    this.guardarDatosCertificacion = this.guardarDatosCertificacion.bind(this);
    this.siguientePaso = this.siguientePaso.bind(this);
    this.anteriorPaso = this.anteriorPaso.bind(this);
    this.generarCertificacion = this.generarCertificacion.bind(this);
    // this.buscarPersona = this.buscarPersona.bind(this);
    this.crearVenta = this.crearVenta.bind(this);
  }

  guardarPersona = persona => {
    this.setState(
      {
        ...this.state,
        persona: {
          ...this.state.persona,
          ...persona,
        },
      },
      () => {
        this.siguientePaso();
      }
    );
  };

  guardarDatosCertificacion(datos) {
    this.setState(
      {
        ...this.state,
        id_TipoCertificacion: datos.id_TipoCertificacion,
        cantidad: datos.cantidad,
        existeVenta: datos.existeVenta,
        detalles: datos.detalles,
        datosPosnet: datos.datosPonset,
        extras: datos.extras,
      },
      function() {
        this.generarCertificacion();
      }
    );

    // this.siguientePaso();
  }

  generarCertificacion() {
    if (!this.state.persona._id) {
      this.props
        .createPers({
          variables: { persona: this.state.persona },
        })
        .then(respuestaPersona => {
          notification.success({
            message: 'Nuevo Ciudadano',
            description: 'Se ha registrado con exito los datos de la persona',
          });

          this.crearVenta(respuestaPersona._id, '');
        })
        .catch(error => {
          console.log('Excepcion!!');
          console.log(error);

          Modal.error({
            title: 'Error en la creacion de la persona',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
        });
    } else {
      //Caso donde ya existia la persona en la BD
      // console.log("Caso donde no debo crear a la persona!");
      this.crearVenta(this.state.persona._id, '');
    }
  }

  // eslint-disable-next-line no-unused-vars
  crearVenta = (idPersona, idOrganismo) => {
    let yo = this;
    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    let { existeVenta, datosPosnet, detalles } = this.state;

    let detallesFiltrados = [];
    detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });
    if (this.state.existeVenta && detalles.length > 0) {
      confirm({
        title: 'Está seguro de que desea crear la certificacion CON VENTA?',
        content: 'No podrá hacer cambios sobre esta certificacion',
        onOk: () => {
          this.setState({
            loading: true,
          });
          this.props
            .insertDetalleVenta({
              variables: { detalleVenta: { detalle: detallesFiltrados } },
            })
            .then(res => {
              //El detalle de venta se inserto correctamente. Ahora debemos crear la venta..
              let detalles = res.data.insertDetalleVenta.detalle;

              let importe = _.sum(
                _.map(detalles, detalle => {
                  //Esta funcion se encarga de multiplicar la cantidad de cada de talle por el valor de cada tipo_sello
                  return detalle.cantidad * detalle.tipo_sello.valor;
                })
              );

              let venta = {
                importe: importe,
                fecha: moment().toDate(),
                idVendedor: this.props.data.getUsuario._id,
                idOrganismo: this.props.data.getUsuario.organismo._id,
                idDetalle_Venta: res.data.insertDetalleVenta._id,
                datosPosnet:
                  datosPosnet &&
                  (datosPosnet.codigoOperacion || datosPosnet.numeroTicket)
                    ? {
                        codigoOperacion: datosPosnet.codigoOperacion,
                        numeroTicket: datosPosnet.numeroTicket,
                        cuenta: 'Tasas',
                      }
                    : null,
              };

              this.props
                .insertVenta({
                  variables: { venta: venta },
                })
                .then(res => {
                  let certificacion = {
                    cantidad: this.state.cantidad,
                    idPersona: this.state.persona._id,
                    idTipo_Certificacion: this.state.id_TipoCertificacion,
                    idOrganismo: this.props.data.getUsuario.organismo._id,
                    idCreador: this.props.data.getUsuario._id,
                    idVenta: res.data.insertVenta._id,
                  };

                  this.props
                    .createCert({
                      variables: { certificacion: certificacion },
                    })
                    .then(respuestaCertificacion => {
                      notification.success({
                        message: 'Venta registrada',
                        description: 'La venta se registro de forma exitosa',
                      });

                      notification.success({
                        message: 'Nueva Certificacion',
                        description:
                          'Se ha registrado con exito la certificacion',
                      });
                      this.setState(
                        {
                          ...this.state,
                          loading: false,
                          guardado: true,
                        },
                        () => yo.props.history.push('/')
                      );

                      //Ambas funciones terminaron correctamente.

                      return respuestaCertificacion.data.insertCertificacion
                        ._id;
                    })
                    .catch(error => {
                      console.log('Excepcion!!');
                      console.log(error);
                      errorService(error, {
                        certificacion: certificacion,
                      });

                      //TODO: Eliminar la vente con su detalle venta en caso de excepcion en la certificacion

                      Modal.error({
                        title: 'Error en la creacion de la certificacion',
                        content:
                          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                      });
                      this.setState({
                        loading: false,
                      });
                    });
                  return res;
                })
                .catch(err => {
                  console.log('Se ha producido un error');
                  console.log(err);
                  errorService(err, {
                    venta: venta,
                  });
                  notification.error({
                    message: 'Error al registrar la venta',
                    description:
                      'Se ha producido un error al registrar la venta',
                  });
                  this.setState({
                    loading: false,
                  });

                  return err;
                });
            })
            .catch(err => {
              console.log(
                'Ocurrio un error a la hora de registrar el detalle de la venta'
              );
              console.log(err);
              errorService(err, {
                detalleVenta: { detalle: detallesFiltrados },
              });

              this.setState({
                loading: false,
              });
              Modal.error({
                title:
                  'Error en la creacion de la venta, compruebe que exista stock por favor',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          errorService(
            new Error(
              'CANCELO LA CREACION DEL TRAMITE CERTIFICACION "CON VENTA" '
            ),
            {
              respuestaServer: yo.state,
              existeVenta: existeVenta,
            }
          );
          yo.setState({
            loading: false,
          });
        },
      });
    } else {
      //caso donde solo debo crear la certificacion:

      //TODO: Cambiar el idOrganismo!
      let certificacion = {
        cantidad: this.state.cantidad,
        fecha_creacion: new Date(),
        idPersona: this.state.persona._id,
        idTipo_Certificacion: this.state.id_TipoCertificacion,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        idCreador: this.props.data.getUsuario._id,
      };

      confirm({
        title: 'Está seguro de que desea crear la certificacion SIN VENTA?',
        content: 'No podrá hacer cambios sobre esta certificacion',
        onOk: () => {
          this.setState({
            loading: true,
          });
          this.props
            .createCert({
              variables: { certificacion: certificacion },
            })
            // eslint-disable-next-line no-unused-vars
            .then(respuestaCertificacion => {
              notification.success({
                message: 'Nueva Certificacion',
                description: 'Se ha registrado con exito la certificacion',
              });
              this.setState({
                ...this.state,
                loading: false,
                guardado: true,
              });
              yo.props.history.push('/');
            })
            .catch(error => {
              console.log('Excepcion!!');
              console.log(error);

              this.setState({
                loading: false,
              });
              Modal.error({
                title: 'Error en la creacion de la certificacion',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
          errorService(
            new Error(
              'CANCELO LA CREACION DEL TRAMITE CERTIFICACION "SIN VENTA" '
            ),
            {
              respuestaServer: yo.state,
              existeVenta: existeVenta,
              certificacion,
            }
          );
          yo.setState({
            loading: false,
          });
        },
      });
    }
  };

  generarCertificacionCompleta = datos => {
    this.setState(
      {
        ...this.state,
        id_TipoCertificacion: datos.id_TipoCertificacion,
        cantidad: datos.cantidad,
        existeVenta: datos.existeVenta,
        detalles: datos.detalles,
        datosPosnet: datos.datosPonset,
        datosMP: datos.datosMP,
        extras: datos.extras,
      },
      () => {
        if (!this.state.persona._id) {
          this.props
            .createPers({
              variables: { persona: this.state.persona },
            })
            .then(respuestaPersona => {
              notification.success({
                message: 'Nuevo Ciudadano',
                description:
                  'Se ha registrado con exito los datos de la persona',
              });

              this.crearCertificacionConVenta(respuestaPersona._id, '');
            })
            .catch(error => {
              console.log('Excepcion!!');
              console.log(error);

              Modal.error({
                title: 'Error en la creacion de la persona',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        } else {
          //Caso donde ya existia la persona en la BD
          // console.log("Caso donde no debo crear a la persona!");
          this.crearCertificacionConVenta(this.state.persona._id, '');
        }
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  crearCertificacionConVenta = (idPersona, idOrganismo) => {
    let yo = this;

    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };
    let { existeVenta, datosPosnet, detalles, extras, datosMP } = this.state;
    let detallesFiltrados = [];
    detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });

    let { email, enviarPorEmail, descargarRecibo } = extras;
    let venta;
    console.info('<--existeVenta-->');
    console.log(existeVenta);
    console.info('<--/existeVenta-->');

    if (existeVenta && detalles.length > 0) {
      venta = {
        idVendedor: this.props.data.getUsuario._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        detalle: detallesFiltrados,
        datosPosnet:
          datosPosnet &&
          (datosPosnet.codigoOperacion || datosPosnet.numeroTicket)
            ? {
                codigoOperacion: datosPosnet.codigoOperacion,
                numeroTicket: datosPosnet.numeroTicket,
                cuenta: 'Tasas',
              }
            : null,
        datosMP: datosMP
          ? { numeroComprobante: datosMP.numeroComprobante }
          : null,
        datosRecibo: {
          email,
          enviarPorEmail,
          descargarRecibo,
        },
      };

      let certificacion = {
        cantidad: this.state.cantidad,
        idPersona: this.state.persona._id,
        idTipo_Certificacion: this.state.id_TipoCertificacion,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        idCreador: this.props.data.getUsuario._id,
      };

      this.props
        .crearCertificacionConVenta({
          variables: { certificacion: certificacion, venta: venta },
        })
        .then(respuestaCertificacion => {
          console.log('Respuesta Certificacion: ', respuestaCertificacion);
          if (venta) {
            notification.success({
              message: 'Venta registrada',
              description: 'La venta se registro de forma exitosa',
            });
          }
          notification.success({
            message: 'Nueva Certificacion',
            description: 'Se ha registrado con exito la certificacion',
          });

          if (
            descargarRecibo &&
            respuestaCertificacion.data.crearCertificacionConVenta &&
            respuestaCertificacion.data.crearCertificacionConVenta.recibo64 &&
            respuestaCertificacion.data.crearCertificacionConVenta.recibo64
              .length > 0
          ) {
            verPdf(
              respuestaCertificacion.data.crearCertificacionConVenta.recibo64,
              `Recibo_Num_${respuestaCertificacion.data.crearCertificacionConVenta.venta.id}`
            );
          }

          this.setState(
            {
              ...this.state,
              loading: false,
              guardado: true,
            },
            () => yo.props.history.push('/')
          );

          //Ambas funciones terminaron correctamente.

          // return respuestaCertificacion.data.insertCertificacion._id;
        })
        .catch(error => {
          console.log('Excepcion!!');
          console.log(error);
          errorService(error, {
            certificacion: certificacion,
          });

          //TODO: Eliminar la vente con su detalle venta en caso de excepcion en la certificacion

          Modal.error({
            title: 'Error en la creacion de la certificacion',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
          this.setState({
            loading: false,
          });
        });
      return true;
    } else {
      let certificacion = {
        cantidad: this.state.cantidad,
        idPersona: this.state.persona._id,
        idTipo_Certificacion: this.state.id_TipoCertificacion,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        idCreador: this.props.data.getUsuario._id,
      };
      this.props
        .createCert({
          variables: { certificacion: certificacion },
        })
        // eslint-disable-next-line no-unused-vars
        .then(respuestaCertificacion => {
          notification.success({
            message: 'Nueva Certificacion',
            description: 'Se ha registrado con exito la certificacion',
          });
          this.setState({
            ...this.state,
            loading: false,
            guardado: true,
          });
          // console.log("LA respuesta es ....");
          // console.log(respuestaCertificacion);
          // return respuestaCertificacion.data.insertCertificacion._id;
          yo.props.history.push('/');
        })
        .catch(error => {
          console.log('Excepcion!!');
          console.log(error);

          this.setState({
            loading: false,
          });
          Modal.error({
            title: 'Error en la creacion de la certificacion',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
        });
    }
  };

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  siguientePaso() {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { Step } = Steps;
    const { data } = this.props;
    const usuario = data ? data.getUsuario : {};
    let { step } = this.state;
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Certificacion</Breadcrumb.Item>
          <Breadcrumb.Item>Nueva</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nueva Certificacion
          </h2>
          <br />
          <Steps className="stepsFormularios" current={step}>
            <Step title="Buscar Persona" />
            <Step title="Datos de la Certificacion" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarPersona} />
            )}
            {step === 1 && (
              <FormCertificacion
                organismo={usuario.organismo}
                onFinalizar={datos => this.guardarDatosCertificacion(datos)}
                onSubmit={datos => this.guardarDatosCertificacion(datos)}
                generarCertificacionCompleta={datos =>
                  this.setState({ loading: true }, () =>
                    this.generarCertificacionCompleta(datos)
                  )
                }
                datos={{ id_TipoCertificacion: '', cantidad: 1 }}
                config={{ creacion: true }}
                loading={this.state.loading}
                usuario={usuario}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearCertificacion);
